import * as React from 'react';
import { Box, ListItemButton, ListItemText } from '@mui/material';

import { IBuildingItem } from 'models';

interface BuildingItemListModeProps {
  building: IBuildingItem;
  selected?: boolean;
  onBuildingItem?: (buildingId: number) => void;
}

export const BuildingItemListMode: React.FC<BuildingItemListModeProps> = (props) => {
  const { building, selected = false, onBuildingItem = () => {} } = props;

  return (
    <ListItemButton
      selected={selected}
      onClick={() => {
        onBuildingItem(building.id);
      }}
    >
      <Box
        sx={{
          marginRight: 2,
          width: 86,
          height: 50,
          borderRadius: 1,
          overflow: 'hidden',
        }}
      >
        <img
          src={building.thumbnail}
          loading="lazy"
          alt="Building - 1275 Pennsylvania Ave NW"
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      </Box>

      <ListItemText primary={building.location} secondary={`${building.floors} floors`} />
    </ListItemButton>
  );
};
